import React from 'react'
import { Link } from 'react-router-dom'
import causesimg from '../../images/cause/img-1.png'
import causesimg2 from '../../images/cause/img-2.jpg'
import causesimg3 from '../../images/cause/img-3.jpg'
import causesimg4 from '../../images/cause/img-4.jpg'
import causesimg5 from '../../images/cause/img-5.jpg'
import causesimg6 from '../../images/cause/img-6.jpg'
import './style.css'

const Causes = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0)
  }

  return (
    <div className="case-area section-padding">
      <div className="container">

        {/* Section Heading */}
        <div className="col-lg-8 offset-lg-2">
          <div className="section-title section-title2 text-center">
            <div className="thumb-text">
              <span>OUR ACTIVITIES</span>
            </div>

            <h2>
              Empowering Through <span className="highlight-red">Arts & Education</span>
            </h2>

            <p>
              Our programs are designed for a wide spectrum of learners — school children,
              adolescents, working women, homemakers, and middle-aged women.
            </p>

            <p>
              Each group is trained using age-appropriate and body-sensitive methodologies
              that strengthen muscles, improve memory and concentration, enhance posture,
              and support overall physical and emotional well-being.
            </p>

            <p>
              Unlike traditional informal training, our syllabus is research-driven and
              developed with the support of experts in performing arts, physiotherapy,
              optometry, occupational therapy, and psychology. This analytical approach
              enables safer practice and long-term development.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="row">

          {/* 1 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Empowering Women Through Arts
                  </Link>
                </h3>
                <p>
                  Training hubs for working women and homemakers focusing on strength,
                  flexibility, stress relief, self-confidence, and holistic wellness.
                </p>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg2} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Performing Arts for Women Prisoners & Juveniles
                  </Link>
                </h3>
                <p>
                  Dance and movement programs supporting emotional healing,
                  rehabilitation, discipline, and self-expression.
                </p>
              </div>
            </div>
          </div>

          {/* 3 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg3} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Performing Arts for Rural & Tribal Communities
                  </Link>
                </h3>
                <p>
                  Expanding access to Indian performing arts while preserving
                  cultural heritage and fostering inclusion.
                </p>
              </div>
            </div>
          </div>

          {/* 4 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg4} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Certification & Career Pathways
                  </Link>
                </h3>
                <p>
                  Government-recognized Certificate and Diploma programs with
                  assured career opportunities in India and abroad.
                </p>
              </div>
            </div>
          </div>

          {/* 5 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg5} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Children’s Holistic Development
                  </Link>
                </h3>
                <p>
                  Programs focusing on posture, body alignment, motor skills,
                  confidence, and emotional resilience.
                </p>
              </div>
            </div>
          </div>

          {/* 6 */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="cause-item">
              <div className="cause-top">
                <div className="cause-img">
                  <img src={causesimg6} alt="" />
                  <div className="case-btn">
                    <Link onClick={ClickHandler} to="/donate" className="theme-btn">
                      Support Now <i className="fa fa-angle-double-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cause-text">
                <h3>
                  <Link onClick={ClickHandler} to="/case-single">
                    Strong Institutional Partnerships
                  </Link>
                </h3>
                <p>
                  Collaborations with schools and colleges offering workshops,
                  stage exposure, and expert guidance.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Causes
